import { useAuth } from '@app/core/auth/authentication/hooks/useAuth';
import { getAppUserDisplayName, getUserInitials } from '@app/helpers/user';
import { defineMessage, useIntl } from 'react-intl';

const adminLabelMessage = defineMessage({
  id: 'core.sidenav.adminIndicatorText',
  defaultMessage: 'Admin',
});

/**
 * Shared account identity for the sidenav rail row and account popover.
 * Superadmin gets a fixed Admin label; otherwise client + user display names.
 */
export function useSidenavAccountIdentity() {
  const { user, client, auth0User, isSuperadmin } = useAuth();
  const $t = useIntl().formatMessage;
  const adminLabel = $t(adminLabelMessage);
  const clientName = isSuperadmin ? adminLabel : (client?.name ?? null);

  return {
    user,
    client,
    isSuperadmin,
    avatarSrc: user.avatar || auth0User?.picture || null,
    initials: getUserInitials(user),
    email: user.email,
    /** Client/org line in the rail (empty string when missing). */
    clientLine: clientName ?? '',
    /** Client chip label in the popover (em dash when missing). */
    clientLabel: clientName ?? '—',
    displayNameMin: isSuperadmin ? 'Admin' : getAppUserDisplayName(user, 'min'),
    displayNameLong: isSuperadmin ? 'Admin' : getAppUserDisplayName(user, 'long'),
  };
}
